




























































// Vue
import { computed, defineComponent, PropType, ref, Ref } from '@vue/composition-api'

// models
import { CessationEmployeeModel, EmployeeModel, CessationHistoryModel } from '@/models/config'
import { Paginator } from '@/models/Pagination'

// services
import { CessationEmployeeService, EmployeeService } from '@/services/config'

// components
import { DataTable } from '@/components/table'

// utils
import { alerts } from '@/utils'

export default defineComponent({
  name: 'HistoryCessationAndReEntry',
  props: {
    employee: {
      type: Object as PropType<EmployeeModel>,
      required: true
    }
  },
  components: {
    DataTable
  },
  setup (props, { emit }) {
    const loading = ref(false)
    const pagination: Ref<Paginator> = ref({
      currentPage: 1,
      total: 0,
      count: 0,
      perPage: 10
    })
    const history: Ref<CessationEmployeeModel[]> = ref([])
    const getHistory = async () => {
      loading.value = true
      const response = await CessationEmployeeService.getByEmployee(Number(props.employee.id), pagination.value.currentPage, pagination.value.perPage)
      history.value = response.objects
      pagination.value = response.pagination
      loading.value = false
    }
    const fields = ref([
      {
        key: 'dateReEntry',
        sortable: true,
        label: 'Fecha de Ingreso'
      },
      {
        key: 'dateCessation',
        sortable: true,
        label: 'Fecha de Cese'
      },
      {
        key: 'reason',
        sortable: true,
        label: 'Motivo de Cese'
      },
      {
        key: 'description',
        sortable: true,
        label: 'Motivo Real de Cese'
      },
      {
        key: 'actions',
        label: 'Acciones'
      }
    ])
    const changePage = (page: number) => {
      pagination.value.currentPage = page
      getHistory()
    }
    const changePerPage = (perPage: number) => {
      pagination.value.perPage = perPage
      pagination.value.currentPage = 1
      getHistory()
    }
    const historyFormat = computed(() => {
      const items: CessationHistoryModel[] = []
      const item: CessationHistoryModel = {
        idCessation: null,
        idReEntry: null,
        idReason: null,
        reason: '',
        dateReEntry: '',
        dateCessation: '',
        description: '',
        canEditReEntry: true
      }
      history.value.forEach((h, index) => {
        item.description = h.description
        item.reason = h.reason?.name || ''
        if (h.type === 0) {
          item.dateCessation = h.date
          item.idCessation = parseInt(String(h.id))
          item.idReason = h.reason_id
          items.push({
            ...item
          })
          item.dateReEntry = ''
          item.dateCessation = ''
          item.idCessation = null
          item.idReason = null
        } else {
          item.dateReEntry = h.date
          item.idReEntry = parseInt(String(h.id))
          if (index === 0) {
            item.canEditReEntry = false
          } else {
            item.canEditReEntry = true
          }
          if (index === history.value.length - 1) {
            items.push({
              ...item
            })
          }
        }
      })
      return items
    })
    getHistory()
    const updateDateReEntry = (item: CessationHistoryModel) => {
      emit('update-date-entry', item)
    }
    const updateDateCessation = (item: CessationHistoryModel) => {
      emit('update-date-cessation', item)
    }

    const resetHistory = async () => {
      const answer = await alerts.confirm('Desea continuar con borrar el historial del empleado?')
      if (answer) {
        loading.value = true
        for (let i = 1; i < history.value.length; i++) {
          await CessationEmployeeService.delete(history.value[i].id)
        }
        await EmployeeService.changeStatus(Number(props.employee.id), true)
        alerts.success()
        emit('reset-history-success')
        getHistory()
        loading.value = false
      }
    }
    return {
      pagination,
      historyFormat,
      fields,
      loading,
      changePage,
      changePerPage,
      updateDateReEntry,
      updateDateCessation,
      resetHistory
    }
  }
})
